import { useAct } from 'FlowBuilder/store'
import './SurveyPageForm.scoped.scss'
import validate from 'Shared/ScriptEditor/functions/validate'
import EditQuestion from './EditQuestion'

export default function SurveyPageForm({ surveyId, pageNumber }) {
  const act = useAct()
  const questions = useSel(s => _.values(s.questions.entities).filter(q => q.active && q.surveyId === surveyId && q.pageNumber === pageNumber))
  const answers = useSel(s => _.values(s.answers.entities))
  const orderedQuestions = _.orderBy(questions, 'digitOrder')
  const memoizedQuestions = useMemo(() => questions, [JSON.stringify(questions)]);
  const memoizedAnswers = useMemo(() => answers, [JSON.stringify(answers)]);

  useEffect(() => {
    const errors = [];
    validate(memoizedQuestions, memoizedAnswers, (validationErrors) => {
      errors.push(...validationErrors);
    });
    act.builder.setValidationErrors(_.uniq(errors));

    return () => act.builder.setValidationErrors([]);
  }, [memoizedQuestions, memoizedAnswers]);

  return <div>
    <h2 className='no-margin-top'>Page {pageNumber}</h2>
    {questions.length === 0 && <p className='dark-grey'>No questions added to this page yet</p>}
    {!surveyId && <p className='dark-grey'>Please save to begin adding questions to your survey</p>}
    {orderedQuestions.map(q => <EditQuestion key={q.id} questionId={q.id} />)}
  </div>
}